import * as Types from './TrackingActionTypes';
import * as TrackingServices from '../../../services/TrackingServices';

export const craeteTrackingAction = (tracking) => {
    return { type: Types.CREATE_TRACKING, payload: tracking };
};

export const readTrackingAction = (trackings, id) => {
    return { type: Types.READ_TRACKING, payload: { trackings, id } };
};

export const updateTrackingAction = (id,tracking) => {
    console.log('in action',tracking,id);
    return { type: Types.UPDATE_TRACKING, payload:{ id,tracking} };
};
export const deleteTrackingAction = (id) => {
    return { type: Types.DELETE_TRACKING, payload: id };
};

export const readTracking = (id = 0) => {
    console.log('In readTracking', id);
    return (dispatch) => {
        if (id === 0) {
            return TrackingServices.getAll()
                .then((tracking) => {
                    dispatch(readTrackingAction(tracking, id));
                })
                .catch((error) => console.log('Error:', error));
        } else {
            console.log('inread');
            return TrackingServices.get(id)
                .then((tracking) => {
                    dispatch(readTrackingAction(tracking, id));
                })
                .catch((error) => console.log('Error:', error));
        }
    };
};

export const createUpdateTracking = (id,tracking) => {
    console.log('in create',tracking);
    return (dispatch) => {
        if (id==0) {
            console.log('In createTracking', tracking);
            return TrackingServices.register(tracking)
                .then((tracking) => {
                    dispatch(craeteTrackingAction(tracking));
                })
                .catch((error) => console.log('Error:', error));
        } else {
            console.log('In UpdateTracking',id);
            return TrackingServices.update(id,tracking)
                .then((id,tracking) => {
                    dispatch(updateTrackingAction(id,tracking));
                })
                .catch((error) => console.log('Error:', error));
        }
    };
};

export const deleteTracking = (id) => {
    console.log('in deleteTracking', id);
    return (dispatch) => {
        return TrackingServices.remove(id)
            .then((trackingId) => {
                dispatch(deleteTrackingAction(trackingId));
            })
            .catch((error) => console.log('Error:', error));
    };
};